import { BUY_URL, X_URL, LOGO_URL } from "@/lib/constants";

const XLogo = ({ size = 16 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" aria-hidden="true">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

export const Nav = () => {
  return (
    <nav
      data-testid="site-nav"
      className="relative z-30 flex items-center justify-between px-4 sm:px-8 lg:px-12 pt-5 pb-2"
    >
      <a
        href="#top"
        data-testid="nav-brand"
        className="font-luckiest text-2xl sm:text-3xl text-black flex items-center gap-3"
      >
        <img
          src={LOGO_URL}
          alt="$DATBIHGAH logo"
          data-testid="nav-logo"
          className="w-10 h-10 sm:w-12 sm:h-12 object-cover border-[3px] border-black rounded-full"
          style={{ boxShadow: "3px 3px 0 #000" }}
        />
        $DATBIHGAH
      </a>
      <div className="hidden md:flex items-center gap-3">
        <a
          data-testid="nav-x-link"
          href={X_URL}
          target="_blank"
          rel="noreferrer"
          aria-label="Follow on X"
          className="btn-chunky btn-black text-sm"
        >
          <XLogo size={16} /> FOLLOW
        </a>
        <a
          data-testid="nav-buy-link"
          href={BUY_URL}
          target="_blank"
          rel="noreferrer"
          className="btn-chunky text-sm"
        >
          BUY $DATBIHGAH →
        </a>
      </div>
      <a
        data-testid="nav-buy-link-mobile"
        href={BUY_URL}
        target="_blank"
        rel="noreferrer"
        className="md:hidden btn-chunky text-xs px-3 py-2"
      >
        BUY →
      </a>
    </nav>
  );
};
